export default __webpack_public_path__ + "static/media/check-plus.21e04df9.svg";